import React, { useState } from 'react';

interface AssetNodeProps {
  asset: any;
  index: number;
}

export const AssetNode: React.FC<AssetNodeProps> = ({ asset, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  const assetData = asset.props?.asset;
  if (!assetData) return null;

  return (
    <div
      className='option'
      style={{
        padding: '4px',
        color: '#666',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: isHovered ? 'rgba(0,0,0,0.02)' : 'transparent',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span
        style={{
          display: 'inline-block',
          width: '18px',
          height: '14px',
        }}
      />
      <span
        style={{
          display: 'inline-block',
          width: '14px',
          height: '14px',
          color: '#dddddd',
          textAlign: 'center',
          marginRight: '4px',
        }}
      >
        ●
      </span>
      <span style={{ flex: '1' }}>{assetData.name || `Asset_${index}`}</span>
    </div>
  );
};
